import { Box, Container, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import PageHeader from 'components/page-header/PageHeader';
import PageTitleMobile from 'components/page-header/PageTitleMobile';
import { withIronSessionSsr } from 'iron-session/next';
import RootLayout from 'layouts/RootLayout';
import { sessionOptions } from 'libs/iron-session';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { NextPageWithLayout } from './_app';
import Image from 'next/image';

const ShippingServiceChargePage: NextPageWithLayout = () => {
  return (
    <>
      <Head>
        <title>การเคลมและเปลี่ยนสินค้า | แลมป์ตั้น</title>
      </Head>
      <Box>
        <PageHeader title={`การเคลมและเปลี่ยนสินค้า`}></PageHeader>
        <PageTitleMobile>{`การเคลมและเปลี่ยนสินค้า`}</PageTitleMobile>
        <Container
          pt={{
            base: 8,
            md: 12,
          }}
          pb={{
            base: 8,
            md: 20,
          }}
        >
          <Heading fontWeight="500" mb={6} fontSize="lg">
            การเคลม/เปลี่ยนสินค้าสำหรับการสั่งซื้อผ่าน LAMPTAN SHOP ONLINE
          </Heading>
          <Heading fontWeight="500" mb={6} fontSize="lg">
            ขั้นตอนการเคลม/เปลี่ยนสินค้า
          </Heading>
          <ul
            style={{
              marginLeft: '20px',
            }}
          >
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              ลูกค้าติดต่อบริษัทฯ
              ในการเคลม/เปลี่ยนสินค้าโดยเเจ้งชื่อผู้สั่งซื้อเเละเลขที่คำสั่งซื้อ
              พร้อมอาการ สาเหตุ เเละ รูปถ่าย เพื่อให้เจ้าหน้าที่เเนะนำเบื้องต้น
              โดยลูกค้าต้องแสดงเอกสารที่สามารถยืนยันการซื้ออขายได้ เช่น
              ใบเสร็จรับเงิน (Receipt) หรือใบกำกับภาษี (Tax Invoice)
              ที่ออกโดยบริษัทฯ
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              บริษัทฯ จะทำการตรวจสอบสินค้าของลูกค้าเบื้องต้น ซึ่งประกอบไปด้วย
              อาการเสียและเงื่อนไขการรับประกันของสินค้า
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              การเคลม/เปลี่ยนสินค้า ลูกค้าจะต้องส่งสินค้าคืนบริษัทฯ
              ในสภาพเดิมที่ลูกค้าได้รับ
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              หากสินค้าของลูกค้าอยู่ในเงื่อนไขการรับประกัน บริษัทฯ
              จะออกใบรับเคลมสินค้า
              และข้อมูลสำหรับจัดส่งสินค้าให้กับลูกค้าในกรณีที่ลูกค้าส่งเคลมผ่านบริการขนส่ง
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              ลูกค้าจะต้องนำส่งสินค้าคืนให้กับทางบริษัทฯ ด้วยตนเอง
              ผ่านขนส่งเอกชน และ
              ลูกค้าจะต้องรับผิดชอบค่าใช้จ่ายในการส่งคืนสินค้าด้วยตนเอง บริษัทฯ
              ขอสงวนสิทธิ์ในการไม่รับเคลมสินค้าที่เสียหายเนื่องจากการขนส่งที่ไม่ได้มาตรฐาน
              ทุกกรณี
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              ลูกค้าควรถ่ายรูป/วิดีโอ
              ของสินค้าก่อนหรือระหว่างการแพ็กสินค้าเพื่อใช้เป็นหลักฐานยืนยันสภาพสินค้า
            </li>
            <li
              style={{
                marginBottom: '4px',
              }}
            >
              สินค้าที่ส่งเคลม จะได้รับการซ่อมแซมหรือเปลี่ยนใหม่
              โดยใช้เวลาทั้งหมดประมาณ 10 วันทำการ นับจากวันที่ บริษัทฯ
              ได้รับสินค้าและส่งสินค้าที่แก้ไขหรือทดแทนออกจากบริษัทฯ
              โดยไม่รวมถึงเวลาในการขนส่ง โดยบริษัทฯ
              จะเป็นผู้รับผิดชอบในการส่งสินค้ากลับไปยังลูกค้าตามมาตรฐานที่บริษัทฯ
              กำหนด
            </li>
          </ul>
        </Container>
      </Box>
    </>
  );
};

ShippingServiceChargePage.getLayout = (page) => {
  return <RootLayout>{page}</RootLayout>;
};

export const getServerSideProps = withIronSessionSsr(async function ({
  req,
  res,
  locale,
}) {
  const _locale = locale || 'th';

  return {
    props: {
      ...(await serverSideTranslations(_locale, ['common'])),
    },
  };
},
sessionOptions);

export default ShippingServiceChargePage;
